import {
  CREATE_TRANSACTION,
  GET_TRANSACTIONS,
  SET_TRANSACTION_LOADING,
  UPDATE_TRANSACTION,
  UPDATE_TRANSACTION_VALUE,
} from "../types/transaction.type";



import { TransactionState } from "../context/TransactionContext";

export const TransactionReducer = (state: TransactionState, action: any) => {
  switch (action.type) {
    case SET_TRANSACTION_LOADING:
      return {
        ...state,
        loading: action.isLoading,
      };
    case CREATE_TRANSACTION:
      return {
        ...state,
        transaction: action.payload,
        isCompleted: true,
      };
      case UPDATE_TRANSACTION:
      return { ...state, user: action.payload };
    case UPDATE_TRANSACTION_VALUE:
      return {
        ...state,
        transaction: { ...state.transaction, ...action.payload },
      };
    case GET_TRANSACTIONS:
      return {
        ...state,
        transactions: action.payload,
      };

    default:
      return state;
  }
};
